// UI text for internal pages (Register, Login, Route modal) in 4 languages.
export const ui = {
  ES: {
    modal: { programsKicker: "PROGRAMAS", chooseRoute: "Elige tu ruta" },
    register: {
      back: "Volver",
      kicker: "REGISTRO",
      join: "Únete a",
      programLabel: "PROGRAMA",
      personalData: "DATOS PERSONALES",
      labels: {
        nombre: "Nombre", apellidos: "Apellidos", email: "Email", password: "Contraseña",
        whatsapp: "WhatsApp", edad: "Edad", pais: "País", ciudad: "Ciudad",
        colegio: "Colegio de procedencia", referencia: "Referencia SUPERA",
      },
      ph: {
        nombre: "Tu nombre", apellidos: "Tus apellidos", email: "tucorreo@ejemplo.com",
        ciudad: "Tu ciudad", colegio: "Nombre del colegio", referencia: "Tu número de referencia",
      },
      referenceNotice: "¿No tienes número de referencia Supera? Solicítalo",
      referenceHere: "AQUÍ",
      consentsLabel: "CONSENTIMIENTOS",
      consents: [
        "Consentimiento parental (menor de edad)",
        "Acepto políticas generales del programa",
        "Acepto políticas administrativas y de pagos",
        "Acepto política de cancelaciones",
      ],
      submit: "Crear mi cuenta SUPERA",
      alreadyAccount: "¿Ya tienes cuenta?",
      loginLink: "Inicia sesión",
      errRequired: "Completa nombre, email y contraseña.",
      errReference: "La referencia SUPERA es obligatoria.",
      errConsent: "Debes aceptar las políticas generales del programa.",
      welcome: "¡Bienvenido a {program}, {name}!",
      notifBody: "{name}, tu ruta {program} te espera. ¡A liderar!",
    },
    login: {
      back: "Volver", welcome: "BIENVENIDO", titlePre: "Iniciar", titleAccent: "sesión",
      email: "Email", password: "Contraseña", enter: "Entrar",
      noAccount: "¿No tienes cuenta?", startHere: "Comienza aquí",
      toastWelcome: "¡Hola de nuevo, {name}!", toastError: "Credenciales incorrectas.",
    },
  },
  EN: {
    modal: { programsKicker: "PROGRAMS", chooseRoute: "Choose your path" },
    register: {
      back: "Back",
      kicker: "SIGN UP",
      join: "Join",
      programLabel: "PROGRAM",
      personalData: "PERSONAL DETAILS",
      labels: {
        nombre: "First name", apellidos: "Last name", email: "Email", password: "Password",
        whatsapp: "WhatsApp", edad: "Age", pais: "Country", ciudad: "City",
        colegio: "School", referencia: "SUPERA reference",
      },
      ph: {
        nombre: "Your first name", apellidos: "Your last name", email: "you@example.com",
        ciudad: "Your city", colegio: "School name", referencia: "Your reference number",
      },
      referenceNotice: "Don't have a Supera reference number? Request it",
      referenceHere: "HERE",
      consentsLabel: "CONSENTS",
      consents: [
        "Parental consent (minor)",
        "I accept the general program policies",
        "I accept the administrative and payment policies",
        "I accept the cancellation policy",
      ],
      submit: "Create my SUPERA account",
      alreadyAccount: "Already have an account?",
      loginLink: "Log in",
      errRequired: "Please fill in name, email and password.",
      errReference: "The SUPERA reference is required.",
      errConsent: "You must accept the general program policies.",
      welcome: "Welcome to {program}, {name}!",
      notifBody: "{name}, your {program} path awaits. Let's lead!",
    },
    login: {
      back: "Back", welcome: "WELCOME", titlePre: "Log", titleAccent: "in",
      email: "Email", password: "Password", enter: "Enter",
      noAccount: "Don't have an account?", startHere: "Start here",
      toastWelcome: "Welcome back, {name}!", toastError: "Invalid credentials.",
    },
  },
  PT: {
    modal: { programsKicker: "PROGRAMAS", chooseRoute: "Escolha seu caminho" },
    register: {
      back: "Voltar",
      kicker: "CADASTRO",
      join: "Junte-se à",
      programLabel: "PROGRAMA",
      personalData: "DADOS PESSOAIS",
      labels: {
        nombre: "Nome", apellidos: "Sobrenome", email: "Email", password: "Senha",
        whatsapp: "WhatsApp", edad: "Idade", pais: "País", ciudad: "Cidade",
        colegio: "Escola de origem", referencia: "Referência SUPERA",
      },
      ph: {
        nombre: "Seu nome", apellidos: "Seu sobrenome", email: "voce@exemplo.com",
        ciudad: "Sua cidade", colegio: "Nome da escola", referencia: "Seu número de referência",
      },
      referenceNotice: "Não tem número de referência Supera? Solicite",
      referenceHere: "AQUI",
      consentsLabel: "CONSENTIMENTOS",
      consents: [
        "Consentimento parental (menor de idade)",
        "Aceito as políticas gerais do programa",
        "Aceito as políticas administrativas e de pagamento",
        "Aceito a política de cancelamento",
      ],
      submit: "Criar minha conta SUPERA",
      alreadyAccount: "Já tem uma conta?",
      loginLink: "Entrar",
      errRequired: "Preencha nome, email e senha.",
      errReference: "A referência SUPERA é obrigatória.",
      errConsent: "Você deve aceitar as políticas gerais do programa.",
      welcome: "Bem-vindo ao {program}, {name}!",
      notifBody: "{name}, o seu caminho {program} espera por você. Vamos liderar!",
    },
    login: {
      back: "Voltar", welcome: "BEM-VINDO", titlePre: "Entrar", titleAccent: "agora",
      email: "Email", password: "Senha", enter: "Entrar",
      noAccount: "Não tem uma conta?", startHere: "Comece aqui",
      toastWelcome: "Olá novamente, {name}!", toastError: "Credenciais incorretas.",
    },
  },
  FR: {
    modal: { programsKicker: "PROGRAMMES", chooseRoute: "Choisissez votre parcours" },
    register: {
      back: "Retour",
      kicker: "INSCRIPTION",
      join: "Rejoignez",
      programLabel: "PROGRAMME",
      personalData: "DONNÉES PERSONNELLES",
      labels: {
        nombre: "Prénom", apellidos: "Nom", email: "Email", password: "Mot de passe",
        whatsapp: "WhatsApp", edad: "Âge", pais: "Pays", ciudad: "Ville",
        colegio: "École d'origine", referencia: "Référence SUPERA",
      },
      ph: {
        nombre: "Votre prénom", apellidos: "Votre nom", email: "vous@exemple.com",
        ciudad: "Votre ville", colegio: "Nom de l'école", referencia: "Votre numéro de référence",
      },
      referenceNotice: "Vous n'avez pas de numéro de référence Supera ? Demandez-le",
      referenceHere: "ICI",
      consentsLabel: "CONSENTEMENTS",
      consents: [
        "Consentement parental (mineur)",
        "J'accepte les politiques générales du programme",
        "J'accepte les politiques administratives et de paiement",
        "J'accepte la politique d'annulation",
      ],
      submit: "Créer mon compte SUPERA",
      alreadyAccount: "Vous avez déjà un compte ?",
      loginLink: "Se connecter",
      errRequired: "Veuillez remplir le nom, l'email et le mot de passe.",
      errReference: "La référence SUPERA est obligatoire.",
      errConsent: "Vous devez accepter les politiques générales du programme.",
      welcome: "Bienvenue à {program}, {name} !",
      notifBody: "{name}, votre parcours {program} vous attend. En route vers le leadership !",
    },
    login: {
      back: "Retour", welcome: "BIENVENUE", titlePre: "Se", titleAccent: "connecter",
      email: "Email", password: "Mot de passe", enter: "Entrer",
      noAccount: "Vous n'avez pas de compte ?", startHere: "Commencez ici",
      toastWelcome: "Ravi de vous revoir, {name} !", toastError: "Identifiants incorrects.",
    },
  },
};

export function fmt(str, vars = {}) {
  return str.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");
}

export const dailyPhrases = {
  ES: [
    "El líder no nace, se forma cada día.",
    "Un gran líder inspira a otros a dar lo mejor de sí.",
    "Tu constancia de hoy es tu liderazgo de mañana.",
    "Liderar es servir con propósito y corazón.",
    "Los verdaderos líderes construyen más líderes.",
    "Cada paso cuenta en tu camino a la grandeza.",
    "El mundo necesita tu voz y tu ejemplo.",
  ],
  EN: [
    "Leaders aren't born, they're built every day.",
    "A great leader inspires others to give their best.",
    "Today's consistency is tomorrow's leadership.",
    "To lead is to serve with purpose and heart.",
    "True leaders build more leaders.",
    "Every step counts on your path to greatness.",
    "The world needs your voice and your example.",
  ],
  PT: [
    "O líder não nasce, forma-se todos os dias.",
    "Um grande líder inspira os outros a darem o seu melhor.",
    "A sua constância de hoje é a sua liderança de amanhã.",
    "Liderar é servir com propósito e coração.",
    "Verdadeiros líderes formam mais líderes.",
    "Cada passo conta no seu caminho para a grandeza.",
    "O mundo precisa da sua voz e do seu exemplo.",
  ],
  FR: [
    "Les leaders ne naissent pas, ils se forgent chaque jour.",
    "Un grand leader inspire les autres à donner le meilleur.",
    "La constance d'aujourd'hui est le leadership de demain.",
    "Diriger, c'est servir avec un but et du cœur.",
    "Les vrais leaders forment d'autres leaders.",
    "Chaque pas compte sur ton chemin vers la grandeur.",
    "Le monde a besoin de ta voix et de ton exemple.",
  ],
};

export function phraseOfDay(lang) {
  const arr = dailyPhrases[lang] || dailyPhrases.ES;
  const day = Math.floor(Date.now() / 86400000);
  return arr[day % arr.length];
}

export const assistantUi = {
  ES: {
    title: "Asistente SUPERA",
    subtitle: "Resuelvo tus dudas sobre Supera",
    greeting: "¡Hola! 👋 Soy el asistente de Supera Leadership. ¿En qué puedo ayudarte hoy?",
    placeholder: "Escribe tu pregunta...",
    send: "Enviar",
    error: "No pude responder. Intenta de nuevo.",
    open: "¿Dudas sobre Supera?",
  },
  EN: {
    title: "SUPERA Assistant",
    subtitle: "I answer your questions about Supera",
    greeting: "Hi! 👋 I'm the Supera Leadership assistant. How can I help you today?",
    placeholder: "Type your question...",
    send: "Send",
    error: "I couldn't reply. Please try again.",
    open: "Questions about Supera?",
  },
  PT: {
    title: "Assistente SUPERA",
    subtitle: "Tiro suas dúvidas sobre a Supera",
    greeting: "Olá! 👋 Sou o assistente da Supera Leadership. Como posso ajudar hoje?",
    placeholder: "Digite sua pergunta...",
    send: "Enviar",
    error: "Não consegui responder. Tente novamente.",
    open: "Dúvidas sobre a Supera?",
  },
  FR: {
    title: "Assistant SUPERA",
    subtitle: "Je réponds à vos questions sur Supera",
    greeting: "Bonjour ! 👋 Je suis l'assistant de Supera Leadership. Comment puis-je vous aider ?",
    placeholder: "Écrivez votre question...",
    send: "Envoyer",
    error: "Je n'ai pas pu répondre. Réessayez.",
    open: "Des questions sur Supera ?",
  },
};
